import Joi from 'joi';
import { VISA_CONSUMER_ID_TYPE } from '../constants/common-enums';

const ConsumerIdentity = Joi.object().keys({
  identityProvider: Joi.string()
    .optional()
    .allow(''),
  identityValue: Joi.string()
    .email({ tlds: { allow: false } })
    .required(),
  type: Joi.string()
    .uppercase()
    .required()
    .valid(VISA_CONSUMER_ID_TYPE),
  usernameType: Joi.string()
    .uppercase()
    .optional()
});

export default ConsumerIdentity;
